function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _default = /*#__PURE__*/function () {
  function _default() {
    _classCallCheck(this, _default);
  }

  _createClass(_default, null, [{
    key: "handleResponse",
    value: function handleResponse(payload, component) {
      if (!Utils.type.isObject(payload)) {
        return;
      }

      var ws = window.vueApp.webSocket;
      Utils.type.ifObject(payload.wsHeader, function (header) {
        Object.assign(ws.header, header);
        console.log("New header: ", ws.header);
      });
      var actionName = payload.action;

      if (actionName.startsWith("component/")) {
        var methodName = actionName.replace(/^component\//, "");
        console.log("Executing component action: ".concat(methodName));
        component["action_".concat(methodName)](payload);
      } else {
        GLib.action.execute(payload, component);
      }
    }
  }]);

  return _default;
}();

export { _default as default };